import { format, parseISO } from 'date-fns';
import { uk } from 'date-fns/locale';

// Same "01.10 (чт)" the bot uses in its messages, so a day reads alike in the chat and the app.
export const formatDayLabel = (dayDate: string) =>
  format(parseISO(dayDate), 'dd.MM (EEEEEE)', { locale: uk });
